import React from 'react'
import PropTypes from 'prop-types'
import { Grid, GridColumn, Icon } from 'semantic-ui-react'
import { Button } from 'react-dxd-components'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { appendList, removeFromList } from '../../../../state/slice/form'

const RemoveRowButton = (onClick, index) => {
  return <Button
    data-testid='remove'
    tertiary
    onClick={() => onClick(index)}>
    <Icon size='large' name='minus circle' />
  </Button>
}

const DynamicList = ({
  path,
  defaultObject,
  RowElement,
  maxLength,
  pathForCount = null,
  disableAppending = false,
  onRemove = removedItem => {}
}) => {

  const dispatch = useDispatch()
  const data = useSelector(state => _.get(state.form, path))

  const append = () => {
    dispatch(appendList(path, defaultObject, pathForCount))
  }

  const remove = (index) => {
    const removedItem = data[index]
    dispatch(removeFromList(path, index, pathForCount))
    onRemove(removedItem)
  }

  return <Grid divided='vertically' container>
    {data?.map((e, index) => {
      return <RowElement
        key={index}
        path={path}
        index={index}
        removeRow={data.length !== 1 ? RemoveRowButton(remove, index) : null}
      />
    })}
    <GridColumn width={2}>
      <Button
        data-testid='append'
        className='u-mB4'
        disabled={maxLength ? data.length === maxLength : disableAppending}
        onClick={append}>
        <Icon name='plus' />
      </Button>
    </GridColumn>
  </Grid>
}

DynamicList.propTypes = {
  /** The redux store object path where the array of objects resides */
  path: PropTypes.string.isRequired,
  /** The store object to insert into the array when appending */
  defaultObject: PropTypes.object.isRequired,
  /** Element (functional component) to render for each array item */
  RowElement: PropTypes.func.isRequired,
  /** A max length for the list, to not allowing appending further. */
  maxLength: PropTypes.number,
  /**
   * In lieu of passing a max length,
   * the parent calling this component can manually disable appending more list items.
   * This is useful when the determining factor is not just the size of *this* list of data.
   */
  disableAppending: PropTypes.bool,
  /** Redux store object path where the 'total' count should be updated upon append/remove */
  pathForCount: PropTypes.string,
  onRemove: PropTypes.func,
}

export default DynamicList